import { createContext, useContext } from "react";

/**
 * Канонический адрес текущей страницы для компонентов, до которых он не прокинут пропами.
 *
 * Нужен разметке Schema.org: узлы связываются через `@id` вида `<canonical>#fragment`, а блоки
 * вроде аккордеона живут глубоко в дереве и своего адреса не знают. В SSR `useLocation` отдаёт
 * не путь страницы, поэтому значение кладёт `Layout` — туда его передаёт `gatsby-plugin-layout`.
 *
 * `null` означает «адрес неизвестен»: потребитель в этом случае отдаёт узел без `@id`,
 * а не выдумывает ссылку.
 */
export const PageCanonicalContext = createContext<string | null>(null);

export const usePageCanonical = (): string | null =>
  useContext(PageCanonicalContext);
